import { fetchData } from '@/services/api/client'
import { PlaceSearchesResponse } from '@/services/api/bff/places/dtos/PlaceSearch.dto'
import { PlacesResponse } from '@/services/api/bff/places/dtos/Place.dto'

export const searchPlace = async (
  term: string,
  options: RequestInit = { cache: 'no-cache' },
): Promise<PlaceSearchesResponse> => {
  const url = `/api/bff/place-searches?include=climate&term=${encodeURIComponent(term)}&client=web`
  return fetchData(url, options)
}

export const fetchPlace = async (
  osmType?: string,
  osmId?: string,
  geohash?: string,
  type?: string,
  options?: RequestInit,
): Promise<PlacesResponse> => {
  let url
  if (geohash) {
    url = `/api/bff/places?filter[geohash]=${geohash}&filter[type]=${type}&client=web`
  } else {
    url = `/api/bff/places?filter[osm_type]=${osmType}&filter[osm_id]=${osmId}&client=web`
  }
  return fetchData(url, options)
}
